import styled from '@emotion/styled';

export const ContentSection = styled.section`
  width: 100%;
  max-width: calc(100% - 64px);
  height: calc(100vh - 164px);
  max-height: 800px;
  background: #f5f5f5;
  padding: 32px;
  margin: 32px auto;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;